<template>
  <h2 class="titleStepForm">
    For Minors Only <sup>(parent/guardian information)</sup>
  </h2>
  <div class="row">
    <div class="col-lg-6 mb-3">
      <div class="form-group">
        <label class="font-size-14"
          >Parent/ Legal Guardian: Name
        </label>
        <input
          type="text"
          v-model="form.personal.parentName"
          class="form-control"
          placeholder="Parent/ Legal Guardian: Name "
          disabled
        />
      </div>
    </div>
    <div class="col-lg-6 mb-3">
      <div class="form-group">
        <label class="font-size-14"
          >Identification No. (ID/ DP/ PP)
        </label>
        <input
          type="text"
          v-model="form.personal.parentId"
          class="form-control"
          placeholder="Identification No. (ID/ DP/ PP) "
          disabled
        />
      </div>
    </div>
    <div class="col-lg-6 mb-3">
      <div class="form-group">
        <label class="font-size-14"
          >Trustee:
          <sup
            >(person authorised to act on behalf of
            minor)</sup
          >
        </label>
        <input
          type="text"
          v-model="form.personal.trusteeName"
          class="form-control"
          placeholder="Parent/ Legal Guardian: Name "
          disabled
        />
      </div>
    </div>
    <div class="col-lg-6 mb-3">
      <div class="form-group">
        <label class="font-size-14"
          >Identification No. (ID/ DP/ PP)
        </label>
        <input
          type="text"
          v-model="form.personal.trusteeId"
          class="form-control"
          placeholder="Identification No. (ID/ DP/ PP) "
          disabled
        />
      </div>
    </div>
  </div>
  <div class="groupFormStyle mt-4">
    <div class="">
      <h3 class="font-size-18">Statement of Declaration</h3>
      <p>FOR PERSON WHO IS NOT PARENT/ GUARDIAN/ TRUSTEE</p>
    </div>
    <div class="">
      <label
        for="declareId"
        class="w-100 b-0 p-relative labelStyleRadioCstm pt-0 pb-0"
      >
        <template v-if="isPdf">
        <!-- Optional form input -->
        </template>
        <template v-if="!isPdf">
        <input
          type="checkbox"
          v-model="form.personal.declaration"
          name="declareNme"
          class="inputRadioCstm d-none"
          id="declareId"
          disabled
        />
        </template>
        <!-- Optional UI element -->
        <div class="d-flex">
          I ,
          <input
            type="text"
            v-model="form.personal.advisor"
            class="form-control mx-1 p-0 w-50"
            style="
              background-color: #fffbf8;
              border: none;
              border-bottom: 1px solid black;
              outline: none;
            "
            disabled
          />
          declare as follows:
        </div>
      </label>
      <ol class="listOlStyle">
        <li>
          That I of my own volition opened an account in the
          name of
          <template v-if="isPdf">
          <strong>
            {{ form.personal.appliname || "undefined" }}
          </strong>
          who is a minor
          </template>
          <template v-if="!isPdf">
          <strong> {{ form.personal.appliname }} </strong> who
          is a minor
          </template>
        </li>
        <li>
          That I am neither parent nor legal guardian of this
          minor
        </li>
        <li>
          That I am aware that I will not have access to any
          funds of this minor’s account unless authorised by
          said minor’s parent or legal guardian.
        </li>
      </ol>
    </div>
  </div>
</template>

<script>
import { bridge } from "../formBridge";

export default {
  name: "ReviewMinors",
  props: {
    variant: { type: String, default: "review" },
  },
  computed: {
    isPdf() {
      return this.variant === "pdf";
    },
  },
  mixins: [
    bridge({
    state: ["form"],
    }),
  ],
};
</script>
